import React from "react";
import { Box, IconButton, TablePagination, Tooltip } from "@mui/material";
import CommonTable, { HeadCell } from "../../../../../business-types/grocery/components/CommonTable";
import ViewListIcon from "@mui/icons-material/ViewList";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";
import { ledgerList } from "src/shared/services/interfacev2";

type LedgerRow = {
  id: string;
  sno: number;
  Name: string;
  PhoneNumber: string;
  OutstandingBalance: string;
  Actions: React.ReactNode;
};

interface LedgerTableProps {
  data: ledgerList[];
  page: number;
  rowsPerPage: number;
  totalRecords: number;
  formatCurrency: (val: number) => string;
  onPageChange: (newPage: number) => void;          
  onRowsPerPageChange: (newRowsPerPage: number) => void; 
  onRowClick: (id: string) => void;
}

const LedgerTable: React.FC<LedgerTableProps> = ({
  data,
  page,
  rowsPerPage,
  totalRecords,
  formatCurrency,
  onPageChange,
  onRowsPerPageChange,
  onRowClick,
}) => {
  // Slice data for current page
  const visibleRows = data.slice(0, rowsPerPage);

  const rows: LedgerRow[] = visibleRows.map((item, index) => ({
    id: item.customerId,
    sno: page * rowsPerPage + index + 1,
    Name: [item.firstName, item.middleName, item.lastName].filter(Boolean).join(" "),
    PhoneNumber: item.phones[0]?.phone || "",
    OutstandingBalance: formatCurrency(Number(item.totalOutstandingBalance)),
    Actions: (
      <Box display="flex" alignItems="center" gap={1}>
        <Tooltip title="View order">
          <IconButton onClick={() => onRowClick(item.customerId)}>
            <ViewListIcon sx={{ color: "#000" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  }));

  const headCells: HeadCell<LedgerRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "Name", label: "Customer Name" },
    { id: "PhoneNumber", label: "Phone Number" },
    { id: "OutstandingBalance", label: "Outstanding Balance", align: "center" },
    { id: "Actions", label: "Actions" },
  ];

  return (
    <div className="w-full overflow-y-auto">
      <CommonTable<LedgerRow>
        // key={rowsPerPage}
        data={rows}
        headCells={headCells}
        showToolbar={false}
        denseDefault={false}
        title="Ledger"
        selectable={false}
        pagenation={false}
        pageSize={rowsPerPage} // dynamically use rowsPerPage
        // onRowClick={(id) => onRowClick(id.toString())}
        className="w-full min-w-[560px]"
      />

      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(_, newPage) => onPageChange(newPage)}
          onRowsPerPageChange={(e) => {
            const newSize = parseInt((e.target as HTMLInputElement).value, 10);
            onRowsPerPageChange(newSize);
            onPageChange(0); // reset to first pages
          }}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default LedgerTable;
